<template>
  <div class="ai-legal">
    <v-menu
      v-model="dialog.display"
      transition="slide-x-reverse-transition"
      :close-on-click="false"
      :close-on-content-click="false"
      min-width="28%"
    >
      <template v-slot:activator="{ on, attrs }">
        <div style="position: fixed; top: 0; right: 0;"
          v-bind="attrs"
          v-on="on"
        >
        </div>
      </template>
      <div class="d-flex align-center white">
        <div class="d-flex align-center white" style="height: calc(100vh - 22px); cursor: pointer;"
          @click="dialog.display = false"
        ><v-icon small color="black" style="margin: 0 2px">mdi-chevron-double-right</v-icon></div>
        <iframe
          :src="iframe.src"
          width="100%"
          style="height: calc(100vh - 22px)"
          frameborder="0"
          allow="clipboard-write"
        ></iframe>
      </div>
    </v-menu>
  </div>
</template>

<script>
export default {
  data () { return {
    dialog: {
      display: false,
    },
    iframe: {
      // src: 'https://ainn-ep-apac-chatbot-dev.azure-entpdy-np.nielsencsp.net/widget?region=ALL&indexType=vector&topK=5&title=Policy%20Bot',
      src: 'https://ainn-ep-apac-chatbot-ui-dev.azure-entpdy-np.nielsencsp.net/Widget',
    }
  }},
  methods: {
    async init () {
      // if (!(await this.checkEnv())) { return }
      // await this.refreshUserWholly(3600)
      // this.userInfoLoaded = true
    },
    callAIlegal () {
      console.log('callAIlegal')
      this.dialog.display = true
    }
  },
  async created() {
    // await this.init()
    this.$eventBus.$on('call-ai-legal', this.callAIlegal)
  },
  beforeDestroy() {
    this.$eventBus.$off('call-ai-legal', this.callAIlegal)
  },
}
</script>

<style lang="sass">
</style>